<template>
  <div class="card">
    <div class="card-body p-0">
      <cardHead :title="'Hotels'"></cardHead>

      <Form
        method="dialog"
        v-slot="{ errors }"
        class="floating-labels p-10"
        ref="form"
      >
        <formGroup
          :title="'CountryId'"
          :as="'select'"
          :disabled="countries.length == 0"
          v-model="countryId"
          :errors="errors"
          @change="get"
        >
          <template #input>
            <option v-for="item in countries" :value="item.Id" :key="item.Id">{{
              item.Name
            }}</option>
          </template>
        </formGroup>
      </Form>
      <dataTable
        :name="'HotelsList'"
        ref="agGrid"
        :columnDefs="columnDefs"
        :data="data"
        @cellClicked="updateShow = $event.data"
      ></dataTable>
    </div>
  </div>
  <update
    v-if="updateShow != null"
    :setModel="updateShow"
    @close="updateShow = null"
  ></update>
</template>

<script>
import update from "./update";
export default {
  name: "hotelsMatchList",
  components: { update },
  data() {
    return {
      data: null,
      countries: [],
      countryId: 228,
      updateShow: null,
      columnDefs: [
        {
          headerName: "Id",
          field: "Id",
          enableRowGroup: true,
          floatingFilter: true,
          filter: "agTextColumnFilter",
          flex: 1,
          cellClick: true,
          minWidth: 80,
        },
        {
          headerName: "DestinationTownName",
          field: "DestinationTownName",
          rowGroup: false,
          enableRowGroup: true,
          floatingFilter: true,
          filter: "agTextColumnFilter",
          flex: 1,
          cellClick: true,
          minWidth: 200,
        },
        {
          headerName: "HotelGroupName",
          field: "HotelGroupName",
          rowGroup: false,
          enableRowGroup: true,
          floatingFilter: true,
          filter: "agTextColumnFilter",
          flex: 1,
          cellClick: true,
          minWidth: 200,
        },
        {
          headerName: "SoftwareName",
          field: "SoftwareName",
          rowGroup: false,
          enableRowGroup: true,
          floatingFilter: true,
          filter: "agTextColumnFilter",
          flex: 1,
          cellClick: true,
          minWidth: 140,
        },
        {
          headerName: "Name",
          field: "Name",
          enableRowGroup: true,
          floatingFilter: true,
          filter: "agTextColumnFilter",
          flex: 1,
          cellClick: true,
          minWidth: 140,
        },
        {
          headerName: "Star",
          field: "Star",
          enableRowGroup: true,
          floatingFilter: true,
          filter: "agTextColumnFilter",
          flex: 1,
          cellClick: true,
          minWidth: 140,
        },
        {
          headerName: "RoomCount",
          field: "RoomCount",
          enableRowGroup: true,
          floatingFilter: true,
          filter: "agTextColumnFilter",
          flex: 1,
          cellClick: true,
          minWidth: 140,
        },
        {
          headerName: "MatchCount",
          field: "MatchCount",
          enableRowGroup: true,
          floatingFilter: true,
          filter: "agTextColumnFilter",
          flex: 1,
          cellClick: true,
          minWidth: 140,
        },
      ],
    };
  },
  created() {
    this.$appAxiosAdmin.get(`Countries`).then((response) => {
      this.countries = response.data;
    });
    this.get();
  },
  methods: {
    get() {
      this.data = null;
      this.$appAxiosAdmin
        .get(`Hotels/Country/` + this.countryId)
        .then((response) => {
          this.data = response.data;
        });
    },
  },
};
</script>
